import View from '../view'
import HTML from '../../../html'
import events from '../../../event-emitter'
import sortBy from '../sort'


export default class PropertyListerView extends View {

    constructor(controller) {
        super(controller)

        this.rowsToShow = 6
    }


    propTitle() {
        return ''
        return HTML('h3')
            .classes('property-view__title')
            .content(this.controller.title)
            .append(
                HTML('span')
                    .classes('property-view__title__city')
                    // .content(this.controller.finderInstance.cityCurrent.list.join(", "))
                    .content(this.controller.finderInstance.cities.filter(c => c.selected && !c.isAll())
                        .map(c => c.name).join(', '))
                    .render(),
            )
            .render()
    }

    listControls() {
        return ''
        var sortASC = this.controller.sortMethod.isASC()

        var sortDirection = HTML('a')
            .classes('property-view__tweaks__sort-direction ' + (sortASC ? 'asc' : 'desc'))
            .attr({ href: '#' })
            .on('click', event => {
                event.preventDefault()
                this.controller.sortMethod.reverse()
                this.controller.updateProps()
            })
            .append(HTML('i').classes('fa fa-sort-amount-asc'))
            .render()

        var usort = HTML('div')
            .classes('property-view__tweaks__sorter')
            .append(
                this.ultraSelect({
                    buttonText: `Sortera efter: ${this.controller.sortMethod.name}`,
                    list: Object.keys(sortBy.options).map(key => {
                        let option = sortBy.options[key]
                        return {
                            attributes: { href: '#' },
                            content: option.name,
                            events: {
                                event: 'click',
                                callback: event => {
                                    event.preventDefault()
                                    this.controller.setSortingMethod(option).updateProps()
                                },
                            },
                        }
                    }),
                }),
            ).render()

        var switchers = this.controller.finderInstance.viewModes.getList().map(mode => {
            var switcher = HTML('a')
                .classes(mode.isActive() ? 'active' : 'inactive')
                .attr({
                    class: `property-view__tweaks__modes__switch`,
                    href: '#',
                })
                .on('click', event => {
                    event.preventDefault()
                    this.controller.finderInstance.viewModes.setActive(mode)
                })
                .append(mode.getFAIcon())
                .render()

            if (mode.isActive()) {
                $(switcher).addClass('active')
            }
            mode.onModeOn(() => { $(switcher).addClass('active') })
            mode.onModeOff(() => { $(switcher).removeClass('active') })

            return switcher
        })

        var modesBlock = HTML('div')
            .classes('property-view__tweaks__modes')
            .append(switchers)
            .render()

        return HTML('div')
            .classes('property-view__tweaks')
            .append(sortDirection, usort, modesBlock)
            .render()
    }

    /**
     * Prepares button and counter for loading more posts
     */
    initObjektsPagination() {
        this.controller.objektsPagination.showOnScreen = this.controller.objektsPagination.perScreen
        this.controller.objektsPagination.moreButton =
            this.controller.props.objekts.length <= this.controller.objektsPagination.showOnScreen
            ? ''
            : HTML('a')
                .classes('load-more-button show-on-objekts')
                .attr({ href: '#' })
                .content(`Ladda mer (${this.controller.props.objekts.length - this.controller.objektsPagination.showOnScreen} kvar)`)
                .on('click', (event, element) => {
                    event.preventDefault()

                    this.controller.objektsPagination.showOnScreen
                        = this.controller.objektsPagination.showOnScreen
                        + this.controller.objektsPagination.perScreen

                    let left = this.controller.props.objekts.length - this.controller.objektsPagination.showOnScreen

                    element.innerHTML = `Ladda mer (${left} kvar)`

                    if (this.controller.objektsPagination.showOnScreen > this.controller.props.objekts.length) {
                        this.controller.objektsPagination.showOnScreen = this.controller.props.objekts.length
                        this.controller.objektsPagination.moreButton = ''
                    }

                    this.controller.updateProps()
                })
                .render()
    }

    propertyTabs(projekts, objekts, areas, removeEmpty = false) {
        // let renderProjekts = !!(projekts && projekts.length > 0);
        let renderObjekts = !!(objekts && objekts.length > 0)
        let renderAreas = !!(areas && areas.length > 0)

        // if (!renderProjekts && !renderObjekts) return false;
        let projektsList = this.projektsList(projekts)
        let objektsList = this.objektsList(objekts)
        let areasList = this.areasList(areas)
        var isProjekts = this.controller.activeTab === 'projekts' ? 'active' : 'inactive'
        var isObjekts = this.controller.activeTab === 'objekts' ? 'active' : 'inactive'
        var isAreas = this.controller.activeTab === 'areas' ? 'active' : 'inactive'
        var projektsCount = this.controller.filteredProps
                            ? this.controller.filteredProps.projekts.length
                            : this.controller.props.projekts.length
        var objektsCount = this.controller.filteredProps
                           ? this.controller.filteredProps.objekts.length
                           : this.controller.props.objekts.length
        var areasCount = areas ? areas.length : 0


        var nav = HTML('nav')
            .classes('ptabs__nav')
            .append(
                // removeEmpty && !renderObjekts ? '' : HTML('a')
                //     .classes(`ptabs__nav__tab ${isObjekts}`)
                //     .attr({ href: '#' })
                //     .content(`Lägenheter (${objektsCount})`)
                //     .on('click', (event, element) => {
                //         event.preventDefault()
                //         $(element).parent().find('.ptabs__nav__tab').removeClass('active').addClass('inactive')
                //         $(element).addClass('active').removeClass('inactive')
                //         $(projektsList).removeClass('visible').addClass('invisible')
                //         $(areasList).removeClass('visible').addClass('invisible')
                //         $(objektsList).addClass('visible').removeClass('invisible')
                //         this.controller.setActiveTab('objekts')
                //     }),
                removeEmpty /*&& !renderProjekts*/ ? '' : HTML('a')
                    .classes(`ptabs__nav__tab ${isProjekts}`)
                    .attr({ href: '#' })
                    .content(`Projekt (${projektsCount})`)
                    .on('click', (event, element) => {
                        event.preventDefault()
                        $(element).parent().find('.ptabs__nav__tab').removeClass('active').addClass('inactive')
                        $(element).addClass('active').removeClass('inactive')
                        $(projektsList).addClass('visible').removeClass('invisible')
                        $(objektsList).removeClass('visible').addClass('invisible')
                        $(areasList).removeClass('visible').addClass('invisible')
                        this.controller.setActiveTab('projekts')
                    }),
                removeEmpty && !renderAreas ? '' : HTML('a')
                    .classes(`ptabs__nav__tab ${isAreas}`)
                    .attr({ href: '#' })
                    .content(`Områden (${areasCount})`)
                    .on('click', (event, element) => {
                        event.preventDefault()
                        $(element).parent().find('.ptabs__nav__tab').removeClass('active').addClass('inactive')
                        $(element).addClass('active').removeClass('inactive')
                        $(projektsList).removeClass('visible').addClass('invisible')
                        $(objektsList).removeClass('visible').addClass('invisible')
                        $(areasList).addClass('visible').removeClass('invisible')
                        this.controller.setActiveTab('areas')
                    }),
            ).render()

        events.once('PropertyList::fillPropertyTabs', () => {
            var tweaks = $(this.controller.listControlsRoot).find('.property-view__tweaks')
            $(this.controller.listControlsRoot).find('.container').remove()
            var cont = HTML('div')
                .classes('container')
                .append(nav, tweaks.get(0))
                .render()
            $(this.controller.listControlsRoot).append(cont)
        })

        return HTML('div')
            .classes('ptabs')
            .append(
                HTML('div')
                    .classes('ptabs__content')
                    .append(projektsList, objektsList, areasList),
            ).render()
    }

    /**
     * Build list of projekts
     * @param {Array} projektsList array of projekts raw data
     * @returns {Node} html element
     */
    projektsList(projektsList) {
        if (projektsList.length === 0) {
            if (this.controller.finderInstance.activePropView !== 'propList') {
                return ''
            }
            return HTML('div')
                .classes(`projekts ${activeTab}`)
                .append(
                    HTML('h3')
                        .classes('see-commande-bostader')
                        .append(
                            HTML('span').content('Inga pågående projekt just nu.'),
                            HTML('a')
                                .content('Kolla kommande bostäder')
                                .attr({ href: '#' })
                                .on('click', event => {
                                    event.preventDefault()
                                    this.controller.finderInstance.setPropView('propFutureList')
                                }),
                        ),
                )
                .render()
        }
        var projekts = projektsList.map(el => {
            return this.projektCard(el)
        }).join('')
        var activeTab = this.controller.activeTab === 'projekts' ? 'visible' : 'invisible'
        return HTML('div')
            .classes(`projekts ${activeTab}`)
            .append(
                HTML('div')
                    .classes('view-mode-container simple-view-mode')
                    .content(projekts),
                HTML('div')
                    .classes('view-mode-container table-view-mode')
                    .append(this.projektsTable(projektsList)),
            )
            .render()
    }

    /**
     * Build list of objekts
     * @param {Array} objektsList array of objekts raw data
     * @param {object} options Additional options
     * @returns {Node} html element
     */
    objektsList(objektsList, options = {}) {
        let objekts = objektsList.map((el, index) => {
            if (index >= this.controller.objektsPagination.showOnScreen) {
                return
            }
            return this.objektCard(el)
        }).join('')

        let activeTab = this.controller.activeTab === 'objekts' ? 'visible' : 'invisible'
        let status = [
            'Till salu',
            'Reserverad',
            'Bokad',
            'Såld'
        ]
        let statusDesc = HTML('div')
            .classes('property-table__description')

        for (let st of status) {
            statusDesc.append(
                HTML('div')
                    .classes('value ' + st.split(' ').join('-'))
                    .append(
                        HTML('span')
                            .classes('circle')
                    )
                    .append(
                        HTML('span')
                            .content(st)
                    )
            )
        }

        return HTML('div')
            .classes(`objekts ${activeTab}`)
            .append(
                HTML('div')
                    .classes('view-mode-container simple-view-mode')
                    .content(objekts),
                HTML('div')
                    .classes('view-mode-container table-view-mode')
                    .append(statusDesc)
                    .append(this.objektsTable(objektsList))
                    .append(
                        HTML('button')
                            .classes('property-button property-table__showMore')
                            .content('Se fler bostäder +')
                            .on('click', () => {
                                this.showMoreRows(this.controller.contentRoot.find('.property-row'))
                            })

                    )
            )
            .render()
    }
    /**
     * Show more property-row in object list by click button
     * @param [rows] jQuery selectors
     */
    showMoreRows(rows) {
        this.rowsToShow = (this.rowsToShow + 5 <= rows.length) ? this.rowsToShow + 5 : rows.length
        this.controller.contentRoot.find('.property-row:lt(' + this.rowsToShow + ')').show()
        if (this.rowsToShow === rows.length) {
            this.controller.contentRoot.find('.property-table__showMore').hide()
        }
    }

    /**
     * Build list of areas
     * @param {object} areasList of cities with arrays of data
     * @returns {Node} html element
     */
    areasList(areasList) {
        let areasWrapper = HTML('div').classes('areas-list')

        let groupedAreas = {}

        for (let area of areasList || []) {
            groupedAreas[area.city.name] || (groupedAreas[area.city.name] = [])
            groupedAreas[area.city.name].push(area)
        }

        for (let [name, posts] of Object.entries(groupedAreas)) {
            let areas = posts.map((el) => {
                return this.areaCard(el)
            }).join('')
            areasWrapper.append(
                HTML('div')
                    .classes('areas-list__city')
                    .append(
                        HTML('h3')
                            .content(name)
                            .classes('areas-list__city-name')
                    )
                    .append(
                        HTML('div')
                            .classes('areas-list__city-areas')
                            .content(areas)
                    )
            )
        }
        areasWrapper.render()


        var activeTab = this.controller.activeTab === 'areas' ? 'visible' : 'invisible'

        return HTML('div')
            .classes(`areas ${activeTab}`)
            .append(
                HTML('div')
                    .classes('view-mode-container simple-view-mode')
                    .append(areasWrapper)
            )
            .render()
    }

    /**
     * Renders single projekt card
     * @param {Object} elem Projekt raw data
     * @returns {string}
     */
    projektCard(elem) {
        var isSald = /sluts[aå]lt/i.test(elem.props.status)
        var price = isSald ? '–' : `${Number.parseInt(elem.props.minPrice)
            .toLocaleString('sv-SE')} kr – ${Number.parseInt(elem.props.maxPrice).toLocaleString('sv-SE')} kr`
        var fee = isSald ? '–' : `${Number.parseInt(elem.props.minFee)
            .toLocaleString('sv-SE')} kr – ${Number.parseInt(elem.props.maxFee).toLocaleString('sv-SE')} kr`

        var properties = [
                `<td class="name">Status:</td><td class="value">
            <span class="highlight highlight--${(elem.props.status || '').split(' ').join('-')}">${elem.props.status}</span>
        </td>`,
                elem.props.minPrice || elem.props.maxPrice
                ? `<td class="name">Pris:</td><td class="value">${price}</td>` : null,
                elem.props.minFee || elem.props.maxFee
                ? `<td class="name">Avgift:</td><td class="value">${fee}</td>` : null,
                elem.props.minRooms || elem.props.maxRooms
                ? `<td class="name">Rum:</td><td class="value">${elem.props.minRooms} rok – ${elem.props.maxRooms} rok</td>`
                : null,
                elem.props.salesText
                ? `<td class="name">Inflyttning:</td><td class="value">${elem.props.salesText}</td>` : null,
            ],
            name = elem.name,
            image = elem.front_image || elem.default_img,
            iconsList = elem.icons.length ? elem.icons : [],
            imageText = elem.text_overlay || ''
        var icons = iconsList.map(el => {
            return `<li class="icons-list__icon">
                <img class="icons-list__icon__image" src="${el.image.sizes.medium}" alt="${el.title}">
              </li>`
        }).join('')

        var content = properties.filter(p => p).map(el => {
            return `
          <tr>
            ${el}
          </tr>
        `
        }).join('')

        var projektName = elem.name || ' '
        const publisher = elem.publisher || {}
        const publisherSpan = publisher ? `<span class="-publisherLogo"><img src="${publisher.logo}" alt="${publisher.label}"/></span>` : ''

        return `
      <div class="property-card projekt-card ${elem.props.status.split(' ').join('-')} category-${elem.props.category}">
          <a href="${elem.permalink}">
              <div class="property-card__image" style="background-image: url('${image}')">
                  <ul class="icons-list">
                      ${icons}
                  </ul>
              </div>
              <div class="property-card__text">
                  <h4 class="property-card__title">
                      <span class="-label">${projektName}</span>
                      <span class="-address">${elem.address}</span>
                      ${publisherSpan}
                  </h4>
                  <div class="content">
                      <table>
                          ${content}
                      </table>
                  </div>
                  ${imageText ? '<div class="property-card__image-text">' + imageText + '</div>' : ''}
              </div>
          </a>
      </div>
    `
    }


    /**
     * Renders single objekt card
     * @param {Object} elem Objekt raw data
     * @returns {string}
     */
    objektCard(elem) {
        var isSald = /s[aå]ld|bokad/i.test(elem.props.status)
        var price = isSald ? '–' : `${Number.parseInt(elem.props.price).toLocaleString('sv-SE')} kr`
        var fee = isSald ? '–' : `${Number.parseInt(elem.props.fee).toLocaleString('sv-SE')} kr`

        var properties = [
                `<td class="name">Status:</td><td class="value">
                    <span class="highlight highlight--${(elem.props.status || '').split(' ').join('-')}">${elem.props.status}</span>
                </td>`,
                elem.props.floor ? `<td class="name">Våning:</td><td class="value">${elem.props.floor}</td>` : null,
                elem.props.price ? `<td class="name">Pris:</td><td class="value">${price}</td>` : null,
                elem.props.fee ? `<td class="name">Avgift:</td><td class="value">${fee}</td>` : null,
                elem.props.rooms ? `<td class="name">Rum:</td><td class="value">${elem.props.rooms} rok</td>` : null,
                elem.props.salesText ? `<td class="name">Inflyttning:</td><td class="value">${elem.props.salesText}</td>`
                                     : null,
            ],
            image = elem.front_image || elem.default_img,
            iconsList = elem.icons || []

        var content = properties.filter(p => p).map(el => {
            return `
          <tr>
            ${el}
          </tr>
        `
        }).join('')

        var icons = iconsList.map(el => {
            return `<li class="icons-list__icon">
                <img class="icons-list__image" src="${el.image.sizes.medium}" alt="${el.title}">
              </li>`
        }).join('')

        const publisher = elem.publisher || {}
        const publisherSpan = publisher ? `<span class="-publisherLogo"><img src="${publisher.logo}" alt="${publisher.label}"/></span>` : ''

        return `
      <div class="property-card objekt-card ${elem.props.status.split(' ').join('-')} rooms-${Math.floor(elem.props.rooms)}">
          <a href="${elem.permalink}">
              <div class="property-card__image" style="background-image: url('${image}')">
                  <ul class="icons-list">
                      ${icons}
                  </ul>
              </div>
              <div class="property-card__text">
                  <h4 class="property-card__title">
                      <span class="-label">${elem.name}</span>
                      <span class="-address">${elem.props.addressLine}</span>
                      ${publisherSpan}
                  </h4>
                  <div class="content">
                      <table>
                        ${content}
                      </table>
                  </div>
              </div>
          </a>
      </div>
    `
    }

    /**
     * Renders single area card
     * @param {Object} elem Area raw data
     * @returns {string}
     */
    areaCard(elem) {
        let image = elem.image || elem.default_img
        return `
      <div class="area-card">
          <a href="${elem.permalink}">
            <div class="area-card__image" style="background-image: url('${image}')">
                <h4 class="area-card__title">${elem.title}
                    <svg width="37" height="71" viewBox="0 0 37 71" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.3897 0.5H0.5V70.5H12.3897C14.6697 70.5 16.7879 69.3222 17.9911 67.3855L35.6371 38.9797C36.9609 36.8487 36.9609 34.1513 35.6371 32.0204L17.9911 3.61455C16.788 1.67781 14.6697 0.5 12.3897 0.5Z" fill="#748592"/>
                    </svg>
                </h4>
                <span class="area-card__arrow icon icon-arrow-long"></span>
            </div>
          </a>
      </div>
    `
    }

    projektsTable(projektsList) {
        var objekts = projektsList.map(o => {
            return this.propertyRow(o, this.controller.projektProps)
        })
        return HTML('table')
            .classes(`property-table projekts-table`)
            .append(
                HTML('tbody')
                    .append(
                        this.propertyHeadersRow(this.controller.projektProps),
                        objekts,
                    ),
            )
            .render()
    }

    objektsTable(objektsList) {
        var objekts = objektsList.map(o => {
            return this.propertyRow(o, this.controller.objektProps)
        })
        return HTML('table')
            .classes(`property-table objekts-table`)
            .append(
                HTML('tbody').append(
                    this.propertyHeadersRow(this.controller.objektProps),
                    objekts,
                ),
            )
            .render()
    }

    propertyHeadersRow(props) {
        return HTML('tr')
            .classes('property-row')
            .append(
                props.map(p => {
                    var active = this.controller.sortMethod.name === p.sortingMethod.name ? ' active' : ''

                    return HTML('td')
                        .classes('property-cell property-cell--header' + active)
                        .append(
                            HTML('a')
                                .attr({ href: '#' })
                                .content(p.name)
                                .append(
                                    active
                                    ? HTML('i')
                                        .classes(
                                            'icon ' + (this.controller.sortMethod.isASC()
                                                     ? 'icon-arrow-down'
                                                     : 'icon-arrow-up'))
                                    : '',
                                )
                                .on('click', (event, element) => {
                                    event.preventDefault()
                                    if (active) {
                                        this.controller.sortMethod.reverse()
                                        this.controller.updateProps()
                                    } else {
                                        this.controller
                                            .setSortingMethod(p.sortingMethod)
                                            .updateProps()
                                    }
                                }),
                        )
                }),
            ).render()
    }

    propertyRow(property, properties) {
        var props = properties.map((prop, i) => {
            let content = prop.getValueFormProperty(property)
            let cellClass = ''

            if (prop.name === 'Status') {
                cellClass = ' -status'
                content += `<span class="circle"></span>`
            }
            return HTML('td')
                .classes('property-cell'+ cellClass)
                .on('click', event => {
                    document.location.href = property.permalink
                })
                .content(content)
                .render()
        })
        return HTML('tr')
            .classes(`property-row ${property.props.status.split(/\s/ig).join("-")}`)
            .append(props)
    }
}
